import { Flex } from '@components';
import { Box, styled } from '@mui/material';

export const Container = styled(Flex)(({ theme }) => ({
  flex: 1,
  flexDirection: 'column',
  paddingTop: theme.spacing(10),
  marginBottom: 0,
}));

export const StyledAboutFund = styled(Box)(({ theme }) => ({
  padding: theme.spacing(16, 0),
  flexDirection: 'column',
  flex: 1,
}));

export const StyledInfoCardContainer = styled(Flex)(({ theme }) => ({
  flex: 3,
  justifyContent: 'flex-end',
  flexWrap: 'wrap',
  flexDirection: 'column',
  position: 'relative',
  [theme.breakpoints.up('md')]: {
    top: -106,
    alignContent: 'flex-start',
    flexDirection: 'row',
  },
}));

export const StyledPortfolioBoxContainer = styled(Flex)(({ theme }) => ({
  alignItems: 'center',
  justifyContent: 'center',
  paddingTop: theme.spacing(8),
  paddingBottom: theme.spacing(4),
  flexDirection: 'column',
  gap: theme.spacing(6),
  [theme.breakpoints.down('sm')]: {
    gap: theme.spacing(2),
  },
}));

export const StyledPortfolioPhotoContainer = styled(Flex)(({ theme }) => ({
  flex: 1,
  width: '100%',
  flexWrap: 'wrap',
  justifyContent: 'center',
  alignItems: 'center',
  padding: theme.spacing(0, 16),
  gap: theme.spacing(8),
  [theme.breakpoints.down('md')]: {
    padding: theme.spacing(0, 10),
  },
}));

export const StyledPortfolioPhoto = styled('img')(({ theme }) => ({
  maxHeight: 27,
}));
